import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DeliveryChecker } from "../DeliveryChecker/DeliveryChecker";
import { SitePopup } from "../SitePopup/SitePopup";

@Component
export class DeliveryCheckerModal extends ThemeComponent {
    @Ref closeModal!: HTMLButtonElement[];
    @Ref modalContent!: HTMLElement;
    @Ref formInModal!: HTMLElement;
    @Ref modalPostcodeInput!: HTMLFormElement;
    @Ref modalFooterTextInsert!: HTMLElement;
    private sitePopup: SitePopup|null = document.querySelector('site-popup');

    init() {
        const deliveryCheckers = document.querySelectorAll<DeliveryChecker>('delivery-checker');

        // Update text if on the page.
        const footerContent = document.querySelector('#modalFooterContent')?.textContent;

        if(footerContent) {
            const doc = new DOMParser().parseFromString(JSON.parse(footerContent).delivery_modal_text, "text/html");
            this.modalFooterTextInsert.innerHTML += doc.documentElement.textContent;
        }

        if(deliveryCheckers) {
            for (const deliveryChecker of deliveryCheckers) {
                this.$subscribe(deliveryChecker.onFormSubmit, (postcode) => {
                    void this.lookupDeliveryPrices(postcode);
                    this.openModal();
                });
            }
        }

        for (const closeModal of this.closeModal) {
            this.$listen(closeModal, 'click', () => {
                this.sitePopup?.close();
            });
        }

        this.$listen(this.formInModal, 'submit', (e) => {
            e.preventDefault();
            const userInputField = this.modalPostcodeInput.value;
            void this.lookupDeliveryPrices(userInputField);
        });
    }

    openModal() {
        this.sitePopup = document.querySelector('.site-popup') as SitePopup;
        const sitePopupContent = this.sitePopup.querySelector('.site-popup__content');
        const content = this.modalContent;

        sitePopupContent?.append(content);
        if (!this.sitePopup) { return; }
        this.sitePopup.open('delivery-checker');
    }

    async lookupDeliveryPrices(postcode:string) {
        const url: string = `https://shipping.sadlers.eastsideco.io/api?postcode=${postcode}`;

        const response = await fetch(url);
        const rates = await response.json();

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        this.resetDeliveryPrices();
        this.setPrices(rates);
    }

    updateFooterText() {

    }

    resetDeliveryPrices() {
        const deliveryTypeFull = document.querySelector('.delivery-type-full .next-day');
        const deliveryTypeHalf = document.querySelector('.delivery-type-half .next-day');
        const deliveryTypeQuarter = document.querySelector('.delivery-type-quarter .next-day');
        const deliveryTypePack = document.querySelector('.delivery-type-pack .next-day');
        const deliveryTypeFullEconomy = document.querySelector('.delivery-type-full .economy');
        const deliveryTypeHalfEconomy = document.querySelector('.delivery-type-half .economy');
        const deliveryTypeQuarterEconomy = document.querySelector('.delivery-type-quarter .economy');
        const deliveryTypePackEconomy = document.querySelector('.delivery-type-pack .economy');

        deliveryTypeFull && (deliveryTypeFull.textContent = 'N/A');
        deliveryTypeHalf && (deliveryTypeHalf.textContent = 'N/A');
        deliveryTypeQuarter && (deliveryTypeQuarter.textContent = 'N/A');
        deliveryTypePack && (deliveryTypePack.textContent = 'N/A');
        deliveryTypeFullEconomy && (deliveryTypeFullEconomy.textContent = 'N/A');
        deliveryTypeHalfEconomy && (deliveryTypeHalfEconomy.textContent = 'N/A');
        deliveryTypeQuarterEconomy && (deliveryTypeQuarterEconomy.textContent = 'N/A');
        deliveryTypePackEconomy && (deliveryTypePackEconomy.textContent = 'N/A');

        const deliverySelectors:HTMLElement | null = document.querySelector('.delivery-free-after');
        deliverySelectors && (deliverySelectors.style.display = 'none');
    }

    setPrices(rates: { [key: string]: string | number }[]) {
        let freeAfter = 0;

        for (const rate of rates) {
            const hasFullPallet = Number(rate.full_pallet_price) >= 0;
            const hasHalfPallet = Number(rate.half_pallet_price) >= 0;
            const hasQuarterPallet = Number(rate.qtr_pallet_price) >= 0;
            const hasPack = Number(rate.pack_price) >= 0;

            if (rate.service_code == 'next_day') {
                const deliveryTypeFull = document.querySelector('.delivery-type-full .next-day');
                deliveryTypeFull && (deliveryTypeFull.textContent =
                    hasFullPallet ? '£' + (Number(rate.full_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypeHalf = document.querySelector('.delivery-type-half .next-day');
                deliveryTypeHalf && (deliveryTypeHalf.textContent =
                    hasHalfPallet ? '£' + (Number(rate.half_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypeQuarter = document.querySelector('.delivery-type-quarter .next-day');
                deliveryTypeQuarter && (deliveryTypeQuarter.textContent =
                    hasQuarterPallet ? '£' + (Number(rate.qtr_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypePack = document.querySelector('.delivery-type-pack .next-day');
                deliveryTypePack && (deliveryTypePack.textContent =
                    hasPack ? '£' + (Number(rate.pack_price) / 100).toFixed(2) : 'N/A');
            }

            if (rate.service_code == 'economy') {
                const deliveryTypeFull = document.querySelector('.delivery-type-full .economy');
                deliveryTypeFull && (deliveryTypeFull.textContent =
                    hasFullPallet ? '£' + (Number(rate.full_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypeHalf = document.querySelector('.delivery-type-half .economy');
                deliveryTypeHalf && (deliveryTypeHalf.textContent =
                    hasHalfPallet ? '£' + (Number(rate.half_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypeQuarter = document.querySelector('.delivery-type-quarter .economy');
                deliveryTypeQuarter && (deliveryTypeQuarter.textContent =
                    hasQuarterPallet ? '£' + (Number(rate.qtr_pallet_price) / 100).toFixed(2) : 'N/A');

                const deliveryTypePack = document.querySelector('.delivery-type-pack .economy');
                deliveryTypePack && (deliveryTypePack.textContent =
                    hasPack ? '£' + (Number(rate.pack_price) / 100).toFixed(2) : 'N/A');
            }

            if (rate.service_code == 'free_delivery') {
                freeAfter = Number(rate.price_min) / 100;
            }
        }

        const freeAfterValue:HTMLElement | null  = document.querySelector('.delivery-free-after-value');
        const deliveryFreeAfter:HTMLElement | null = document.querySelector('.delivery-free-after');

        if (freeAfter != 0) {
            freeAfterValue && (freeAfterValue.textContent = `${freeAfter}`);
            deliveryFreeAfter && (deliveryFreeAfter.style.display = 'block');
        } else {
            deliveryFreeAfter && (deliveryFreeAfter.style.display = 'none');
        }
    }
}
